import { EventEmitter } from "@angular/core";

export class PopupControl {
	
	public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	private _visible: boolean = false;
	
	public set visible(value: boolean) {
		this._visible = value;

		this.visibleChange.emit(this._visible);
	}
	public get visible(): boolean {
		return this._visible;
	}

	public show(): void {
		this.visible = true;
	}

	public hide(): void {
		this.visible = false;
	}
	
	public toggleVisibility(): void {
		this.visible = !this.visible;
	}

	public showTitle: boolean = true;
	public description: string;

	public onHidden: EventEmitter<any> = new EventEmitter<any>();
	public onShown: EventEmitter<any> = new EventEmitter<any>();
	
	public onDisposing: EventEmitter<any> = new EventEmitter<any>();

	public options: PopupControlOptions;

	constructor(
		options?: PopupControlOptions
	) {
		this.options = Object.assign({...PopupControlOptions.DEFAULT}, options);
	}
}

export class PopupControlOptions {
	public title?: string = 'DEFAULT TITLE';
	
	public minWidth?: string | number | Function = 350;
	public width?: string | number | Function = 400;
	public maxWidth?: string | number | Function = 'auto';
	
	public minHeight?: string | number | Function = 'auto';
	public height?: string | number | Function = 'auto';
	public maxHeight?: string | number | Function = 'auto';

	public static readonly DEFAULT = {
		title:			'DEFAULT TITLE',

		minWidth:		350,
		width:			400,
		maxWidth:		'auto',
	
		minHeight:	'auto',
		height:			'auto',
		maxHeight:	'auto',
	};
}
